import React from "react";
import PropTypes from 'prop-types';

import Button from "../Button/Button";

import styles from "./loadingErrorFallback.scss";

function LoadingErrorFallback(props) {
    const {text, onRetry} = props;
    return (
        <div className={styles.loadingError}>
            <p>{text}</p>
            <Button text="Повторить" size={"s"} onClick={onRetry} level={"secondary"} />
        </div>
    );
}

LoadingErrorFallback.propTypes = {
    text: PropTypes.string.isRequired,
    onRetry: PropTypes.func
}

export default LoadingErrorFallback;